import React, { useState, useEffect } from 'react';
import { Button, Modal, Radio, Select, TreeSelect } from 'antd';

const { SHOW_PARENT } = TreeSelect;

function AddProductModal({
  visible,
  setVisible,
  dropDownData,
  productsList,
  addProduct,
  selectedSubCategoryIds
}) {
  const [addProductOption, setAddProductOption] = useState(1);
  const [selectedValue, setSelectedValue] = useState(null);
  const [value, setValue] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(true);

  // const getCategoryOptions = () => {
  //   setCategoryLoading(true);
  //   const formattedTreeData = dropDownData
  //     .filter(item => item.SubCategories.length > 0)
  //     .map((category) => {
  //       // Check if all subcategories of this category are in selectedSubCategoryIds
  //       const allSubCategoriesSelected = category.SubCategories.every(subCategory =>
  //         selectedSubCategoryIds.includes(subCategory.SubCategoryId)
  //       );
  //       return {
  //         title: category.CatName,
  //         value: category.CatId,
  //         key: category.CatId,
  //         disabled: allSubCategoriesSelected, // Disable category if all subcategories are selected
  //         children: category.SubCategories.map((subCategory) => ({
  //           title: subCategory.SubCatName,
  //           value: `${category.CatId}-${subCategory.SubCategoryId}`,
  //           key: `${category.CatId}-${subCategory.SubCategoryId}`,
  //           disabled: selectedSubCategoryIds.includes(subCategory.SubCategoryId), // Disable subcategory if it's selected
  //         })),
  //       };
  //     });

  //   setTreeData(formattedTreeData);
  //   setCategoryLoading(false);
  // };
  // Enhance productsList to include 'disabled' property

  const getCategoryOptions = () => {
    setCategoryLoading(true);
    const formattedTreeData = dropDownData
      .filter(item => Array.isArray(item.SubCategories) && item.SubCategories.length > 0)
      .map((category) => {
        const subCategoryNodes = category.SubCategories.map((subCategory) => {
          const selectedSubCategory = selectedSubCategoryIds.find(
            (selected) => selected.SubCategoryId === subCategory.SubCategoryId
          );
          // Check if all Products in this SubCategory have all SubProducts disabled
          const allProductsDisabled = (subCategory.Products || []).every((product) => {
            return (
              product.SubProducts &&
              product.SubProducts.length > 0 &&
              product.SubProducts.every((subProduct) =>
                selectedSubCategory?.selectedProducts.some(
                  (selectedProduct) =>
                    selectedProduct.ProductId === product.ProductId &&
                    selectedProduct.selectedSubProducts.some(
                      (selectedSubProduct) => selectedSubProduct.subProductId === subProduct.subProductId
                    )
                )
              )
            );
          });

          // const allProductsDisabled = []

          // = (subCategory.Products || []).every((product) => {
          //   return (
          //     product.SubProducts &&
          //     product.SubProducts.length > 0 &&
          //     product.SubProducts.every((subProduct) =>
          //       selectedSubCategory?.selectedProducts.some((selectedProduct) =>
          //         selectedProduct.ProductId === product.ProductId &&
          //         selectedProduct.selectedSubProducts.length === product.SubProducts.length && // Ensure all sub-products are selected
          //         selectedProduct.selectedSubProducts.every(
          //           (selectedSubProduct) => product.SubProducts.some(
          //             (pSubProduct) => pSubProduct.subProductId === selectedSubProduct.subProductId
          //           )
          //         )
          //       )
          //     )
          //   );
          // });

          return {
            title: subCategory.SubCatName,
            value: `${category.CatId}-${subCategory.SubCategoryId}`,
            key: `${category.CatId}-${subCategory.SubCategoryId}`,
            disabled: allProductsDisabled, // Disable SubCategory if all its Products' SubProducts are disabled
          };
        });

        const allSubCategoriesDisabled = subCategoryNodes.length > 0 && subCategoryNodes.every((sc) => sc.disabled);

        return {
          title: category.CatName,
          value: category.CatId,
          key: category.CatId,
          disabled: allSubCategoriesDisabled, // Disable Category if all SubCategories are disabled
          children: subCategoryNodes.length > 0 ? subCategoryNodes : undefined,
        };
      });

    setTreeData(formattedTreeData);
    setCategoryLoading(false);
  };

  // const enhancedProductsList = productsList.map(product => ({
  //   ...product,
  //   disabled: selectedSubCategoryIds.includes(product.SubCategoryId)
  // }));

  const selectedSubProductIds = new Set();

  selectedSubCategoryIds.forEach((subCategory) => {
    subCategory.selectedProducts.forEach((product) => {
      product.selectedSubProducts.forEach((subProduct) => {
        selectedSubProductIds.add(subProduct.subProductId);
      });
    });
  });

  const enhancedProductsList = productsList.map((product) => {
    const isSubProductSelected = selectedSubProductIds.has(product.SubProductId);
    return { ...product, disabled: isSubProductSelected };
  });

  const onChange = (newValue) => {
    setValue(newValue);
  };

  const handleAddProduct = () => {
    const formattedData = value.map(item => {
      if (typeof item === 'number') {
        const dataObj = dropDownData.find(item2 => item2.CatId === item);
        return {
          catId: dataObj.CatId,
          catName: dataObj.CatName,
          subCatId: dataObj.SubCategories.map(subCat => subCat.SubCategoryId),
          productCode: 0,
          productList: ''
        }
      } else {
        const dataObj = dropDownData.find(item2 => item2.CatId === parseInt(item.split('-')[0]));
        return {
          catId: dataObj.CatId,
          catName: dataObj.CatName,
          subCatId: [item.split('-').slice(1).join('-')],
          productCode: 0,
          productList: ''
        }
      }
    });

    const mergedData = Object.values(
      formattedData.reduce((acc, item) => {
        const key = item.catId;
        if (!acc[key]) {
          acc[key] = { ...item };
        } else {
          acc[key].subCatId = [...acc[key].subCatId, ...item.subCatId];
        }
        return acc;
      }, {})
    );
    addProduct({ productCode: addProductOption, categoryList: mergedData })
  };

  const handleRadioChange = (e) => {
    setAddProductOption(e.target.value);
    setSelectedValue(null); // Reset selected value when changing the option
    setValue([])
  };

  const tProps = {
    treeData,
    value,
    onChange,
    treeCheckable: true,
    showCheckedStrategy: SHOW_PARENT,
    placeholder: 'Please select',
    style: {
      width: '100%',
    },
    loading: categoryLoading,
    treeNodeFilterProp: "title",
    filterTreeNode: (input, node) =>
      node.title.toLowerCase().includes(input.toLowerCase())
  };

  useEffect(() => {
    if (visible) {
      setAddProductOption(1);
      setSelectedValue(null);
      setTreeData([]);
      setCategoryLoading(true);
      getCategoryOptions();
    }
  }, [visible]);

  return (
    <Modal
      title='Add Product To Count Sheet'
      open={visible}
      onCancel={() => setVisible(false)}
      closable
      footer={[
        <Button
          className='Deactivate-Button'
          key="cancel"
          onClick={() => setVisible(false)}
        >
          Cancel
        </Button>,
        <Button
          className='printButton'
          key="add"
          onClick={() => { addProductOption === 0 ? handleAddProduct() : addProduct({ productCode: addProductOption, ...selectedValue }) }}
        >
          Add Product{addProductOption ? '' : 's'}
        </Button>
      ]}
    >
      <div>
        <Radio.Group
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
          }}
          options={[
            { value: 1, label: 'Add one product' },
            { value: 0, label: 'Add all products in a category' },
          ]}
          value={addProductOption}
          onChange={handleRadioChange}
        />
      </div>
      {addProductOption === 1
        ? (
          <div>
            <p style={{ margin: '10px 0', color: '#7b7b7b' }}>
              You can add an existing product to your count sheet below. If you need to create a new product, go to the "Products" page and click "Add Product."
            </p>
            <div>
              <label className='label'>Product</label>
              <Select
                value={selectedValue}
                onChange={(value, options) => { setSelectedValue(options); }}
                options={enhancedProductsList}
                placeholder='Enter at least 2 characters to search for a Product'
                showSearch
              />
            </div>
          </div>
        ) : (
          <div>
            <p style={{ margin: '10px 0', color: '#7b7b7b' }}>
              Below, you can pick an existing Category to add all of the products in the category to your count sheet.
            </p>
            <div>
              <label className='label'>Category</label>
              <TreeSelect {...tProps} />
            </div>
          </div>
        )
      }
    </Modal>
  )
}

export default AddProductModal;
